<template>
    <div class="product-content">
        <div class="common-seach-wrap">
            <el-button type="primary" icon="el-icon-circle-plus" @click="doAdd()" >新增数值</el-button>
        </div>
        <div class="table-wrap" style="margin-top: 10px">
            <el-table size="small" :data="tableList" border style="width: 100%" v-loading="loading">
                <el-table-column prop="id" label="ID" width="60"></el-table-column>
                <el-table-column prop="point_number" label="数值" ></el-table-column>
                <el-table-column  fixed="right" label="操作" width="100">
                    <template slot-scope="{ row }">
                        <el-button type="text" size="small" @click="doAdd(row)">编辑</el-button>
                        <el-button type="text" size="small" @click="doDelete(row)">删除</el-button>
                    </template>

                </el-table-column>
            </el-table>
        </div>
        <el-dialog title="数值" :visible.sync="dialog" @close="close" :close-on-click-modal="false" :close-on-press-escape="false" width="900px">
            <el-form size="small" :model="form" label-width="120" ref="form">
                <el-form-item label="数值" prop="address">
                    <el-input type="number" v-model="form.point_number" placeholder="提现数值" clearable/>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="close">取 消</el-button>
                <el-button type="primary" @click="save" :disabled="submit_loading">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import points from "@/api/points";

    export default {
        data(){
            return{
                dialog:false,
                form:{
                    id:0,
                    point_number:''
                },
                submit_loading:false,
                tableList:[],
                loading:false,
            }
        },
        mounted() {
            this.loadData();
        },
        methods:{
            doAdd(row = {}){
                if(row){
                    this.form.id = row.id;
                    this.form.point_number = row.point_number
                }
                this.dialog = true;
            },
            doDelete(row){
                this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let formData = {id:row.id};
                    points.deletePointNumber(formData).then(res=>{
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.loadData();
                    });
                })
            },
            close(){
                this.dialog = false;
                this.form = this.$options.data().form;
            },
            loadData(){
                this.loading = true;
                points.getPointNumberList({}).then(res=>{
                    if(res.data){
                        this.tableList = res.data;
                    }
                    this.loading = false;
                    console.log(res);
                })
            },
            save(){
                let formData = this.form;
                points.savePointNumber(formData).then(res=>{
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    });
                    this.loadData();
                    this.close();
                })

            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/user/balance/part/pointsNumber.vue